const MARVIN_API_URL = process.env.VUE_APP_MARVIN_URL || "http://localhost:8100";

/**
 * Send message to Marvin Knowledge API and receive SSE stream.
 */
export async function sendMarvinMessage({ message, conversationId = null }) {
  const senderName = [
    localStorage.getItem("firstname"),
    localStorage.getItem("lastname"),
  ]
    .filter(Boolean)
    .join(" ");

  const body = {
    message,
    ...(conversationId && { conversation_id: conversationId }),
    ...(senderName && { sender_name: senderName }),
  };

  const response = await fetch(`${MARVIN_API_URL}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `HTTP ${response.status}`);
  }

  return response;
}

/**
 * Parse SSE stream from fetch response.
 * Yields text chunks as they arrive.
 */
export async function* streamMarvinResponse(response) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (line.startsWith("data: ")) {
          const data = line.slice(6).trim();
          if (data === "[DONE]") return;

          try {
            const parsed = JSON.parse(data);
            if (parsed.text) yield parsed.text;
            if (parsed.error) throw new Error(parsed.error);
          } catch (e) {
            if (e.message && !e.message.includes("JSON")) throw e;
          }
        }
      }
    }
  } finally {
    reader.releaseLock();
  }
}
